import LoggingService from "../utils/logging";
import { getRequest, postRequest, putRequest } from "./base";
import { responseErrorInterceptor } from "./interceptors";

function getResponseTime(startTime) {
  return new Date().getTime() - startTime;
}

function withLoggingAndPreprocessing(reqPromise) {
  const startTime = new Date().getTime();
  return reqPromise
    .then((response) => {
      if (response.status === 200) {
        LoggingService.logApiCall(response, getResponseTime(startTime));
        return { response };
      }
      LoggingService.logApiError(response, getResponseTime(startTime));
      responseErrorInterceptor(response);
      return { error: response };

    })
    .catch((error) => {
      LoggingService.logApiError(error, getResponseTime(startTime));
      return { error };
    });
}

export function get(url, data, headers) {
  return withLoggingAndPreprocessing(getRequest(url, data, headers));
}

export function post(url, data, headers) {
  return withLoggingAndPreprocessing(postRequest(url, data, headers));
}

export function put(url, data, headers) {
  return withLoggingAndPreprocessing(putRequest(url, data, headers));
}
